import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { db } from '../lib/supabase'

export default function Descuentos() {
  const [seoConfig, setSeoConfig] = useState(null)
  const [heroConfig, setHeroConfig] = useState(null)
  const [descuentos, setDescuentos] = useState([])

  useEffect(() => {
    const load = async () => {
      const { data: seo } = await db.getSEOConfig('descuentos')
      setSeoConfig(seo || null)
      const { data: hero } = await db.getConfiguracionPortada('descuentos')
      setHeroConfig(hero || null)
      const { data: list } = await db.getDescuentos()
      setDescuentos(list || [])
    }
    load()
  }, [])

  // Mostrar todos los descuentos activos y publicados (sin filtro de fecha)
  const activeDescuentos = descuentos || []

  return (
    <>
      <Helmet>
        <title>{seoConfig?.meta_title || 'Descuentos - Plaza Aurora Outlet'}</title>
        <meta name="description" content={seoConfig?.meta_description || 'Promociones y descuentos exclusivos en Plaza Aurora Outlet'} />
        <link rel="canonical" href={seoConfig?.canonical_url || `${import.meta.env.VITE_SITE_URL || 'https://plazaaurora.pe'}/descuentos`} />
        <meta name="robots" content={seoConfig?.robots_index === false ? 'noindex,nofollow' : 'index,follow'} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoConfig?.og_title || seoConfig?.meta_title || 'Descuentos - Plaza Aurora Outlet'} />
        <meta property="og:description" content={seoConfig?.og_description || seoConfig?.meta_description || 'Promociones y descuentos exclusivos en Plaza Aurora Outlet'} />
        {seoConfig?.og_image_url && <meta property="og:image" content={seoConfig.og_image_url} />}
      </Helmet>

      {seoConfig?.json_ld && (
        <script type="application/ld+json">{seoConfig.json_ld}</script>
      )}

      {/* Main Content */}
      <main>
        <div className="container" style={{
          maxWidth: 'var(--container-max-width)',
          margin: '0 auto',
          padding: '0 1rem'
        }}>
          {/* Hero Section */}
          <section id="hero_main" role="region" aria-label="Hero Descuentos" style={{ marginTop: '1.5rem' }}>
            <div className="heroContainer" style={{
              display: 'grid',
              gridTemplateColumns: '1fr 0.9fr',
              alignItems: 'center',
              gap: '1.5rem',
              padding: '1.25rem',
              background: 'var(--color-accent-gray)',
              borderRadius: 'var(--radius-lg)',
              overflow: 'hidden'
            }}>
              <div className="heroLeft" style={{ padding: '1rem' }}>
                <h1 className="heroTitle" style={{
                  fontFamily: 'var(--font-display)',
                  fontWeight: 'var(--font-weight-bold)',
                  lineHeight: '0.95',
                  color: 'var(--color-text-primary)',
                  margin: '0 0 1rem 0'
                }}>
                  {heroConfig?.hero_titulo || 'Descuentos Exclusivos'}<br/>
                </h1>
                <p className="heroDescription" style={{
                  fontFamily: 'var(--font-ui)',
                  fontSize: 'var(--font-size-lead)',
                  color: 'var(--color-text-muted)',
                  maxWidth: '48ch',
                  lineHeight: 'var(--line-height-relaxed)',
                  marginBottom: '1.5rem'
                }}>
                  {heroConfig?.hero_descripcion || 'Aprovecha las mejores promociones y ofertas especiales en Plaza Aurora Outlet 🎯'}
                </p>
                <div className="heroActions" style={{ display: 'flex', gap: '0.75rem' }}>
                  <Link 
                    to={heroConfig?.hero_boton_1_url || '/descuentos'} 
                    className={heroConfig?.hero_boton_1_estilo === 'outline' ? 'btnOutline' : 'btnPrimary'} 
                    style={{
                      padding: '0.6rem 1.1rem',
                      background: 'var(--color-cta-bg)',
                      color: 'var(--color-cta-text)',
                      borderRadius: 'var(--radius-sm)',
                      fontWeight: 'var(--font-weight-bold)',
                      cursor: 'pointer',
                      transition: 'background-color 0.2s ease, color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease',
                      fontSize: 'var(--font-size-body)',
                      textDecoration: 'none',
                      display: 'inline-block'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)'
                      e.currentTarget.style.boxShadow = '0 0 0 3px var(--brand-blue-200)'
                      e.currentTarget.style.background = 'var(--brand-blue)'
                      e.currentTarget.style.color = 'white'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)'
                      e.currentTarget.style.boxShadow = 'none'
                      e.currentTarget.style.background = 'var(--color-cta-bg)'
                      e.currentTarget.style.color = 'var(--color-cta-text)'
                    }}
                    onMouseDown={(e) => {
                      e.currentTarget.style.boxShadow = '0 0 0 3px var(--brand-blue-400)'
                      e.currentTarget.style.background = 'var(--brand-blue-600)'
                    }}
                    onTouchStart={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)'
                      e.currentTarget.style.boxShadow = '0 0 0 3px var(--brand-blue-200)'
                      e.currentTarget.style.background = 'var(--brand-blue)'
                      e.currentTarget.style.color = 'white'
                    }}
                    onTouchEnd={(e) => {
                      setTimeout(() => {
                        e.currentTarget.style.transform = 'translateY(0)'
                        e.currentTarget.style.boxShadow = 'none'
                        e.currentTarget.style.background = 'var(--color-cta-bg)'
                        e.currentTarget.style.color = 'var(--color-cta-text)'
                      }, 150)
                    }}
                  >
                    {heroConfig?.hero_boton_1_texto || 'Ver Descuentos'}
                  </Link>
                  <Link to={heroConfig?.hero_boton_2_url || '/marcas'} className={heroConfig?.hero_boton_2_estilo === 'primary' ? 'btnPrimary' : 'btnOutline'} style={{
                    padding: '0.6rem 1.1rem',
                    background: 'transparent',
                    border: '1px solid var(--color-stroke)',
                    borderRadius: 'var(--radius-sm)',
                    cursor: 'pointer',
                    transition: 'transform 0.2s ease, background-color 0.2s ease',
                    fontSize: 'var(--font-size-body)',
                    color: 'var(--color-text-primary)',
                    textDecoration: 'none',
                    display: 'inline-block'
                  }}>
                    {heroConfig?.hero_boton_2_texto || 'Ver Tiendas'}
                  </Link>
                </div>
              </div>
<div className="heroRight" style={{ height: '100%' }}>
  {heroConfig?.hero_imagen_url ? (
    <img
      className="heroImage"
      src={heroConfig.hero_imagen_url}
      alt={heroConfig?.hero_imagen_alt || 'Descuentos Plaza Aurora'}
      style={{
        width: '100%',
        height: '420px',
        objectFit: 'cover',
        borderRadius: 'var(--radius-md)'
      }}
    />
  ) : (
    <div
      style={{
        width: '100%',
        height: '420px',
        borderRadius: 'var(--radius-md)',
        background: 'var(--color-accent-gray)'
      }}
    />
  )}
</div>
            </div>
          </section>
        </div>

        {/* Promo Strip - Full Width */}
        <section id="promo_strip" role="complementary" aria-label="Promo marquee" style={{ 
          marginTop: '1.5rem', 
          overflow: 'hidden', 
          display: heroConfig?.marquee_activo === false ? 'none' : 'block'
        }}>
          {heroConfig?.marquee_link_url
            ? (heroConfig.marquee_link_url.startsWith('/')
                ? (
                  <Link to={heroConfig.marquee_link_url} style={{ textDecoration: 'none', cursor: 'pointer' }}>
                    <div className="marquee" style={{
                      background: 'var(--color-black-block)',
                      color: 'var(--color-cta-text)',
                      fontFamily: 'var(--font-display)',
                      fontSize: '0.875rem',
                      padding: '0.5rem 0',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      transition: 'opacity 0.2s ease'
                    }}>
                      <div className="marquee-content" style={{
                        display: 'inline-block',
                        animation: 'scroll-left 25s linear infinite',
                        paddingLeft: '100%'
                      }}>
                        {heroConfig?.marquee_texto || '★ OFERTAS EXCLUSIVAS  •  DESCUENTOS LIMITADOS  •  AHORRA MÁS  •  PROMOCIONES ESPECIALES  •  OFERTAS EXCLUSIVAS  •  DESCUENTOS LIMITADOS  •  AHORRA MÁS  •  PROMOCIONES ESPECIALES'}
                      </div>
                    </div>
                  </Link>
                ) : (
                  <a href={heroConfig.marquee_link_url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', cursor: 'pointer' }}>
                    <div className="marquee" style={{
                      background: 'var(--color-black-block)',
                      color: 'var(--color-cta-text)',
                      fontFamily: 'var(--font-display)',
                      fontSize: '0.875rem',
                      padding: '0.5rem 0',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      transition: 'opacity 0.2s ease'
                    }}>
                      <div className="marquee-content" style={{
                        display: 'inline-block',
                        animation: 'scroll-left 25s linear infinite',
                        paddingLeft: '100%'
                      }}>
                        {heroConfig?.marquee_texto || '★ OFERTAS EXCLUSIVAS  •  DESCUENTOS LIMITADOS  •  AHORRA MÁS  •  PROMOCIONES ESPECIALES  •  OFERTAS EXCLUSIVAS  •  DESCUENTOS LIMITADOS  •  AHORRA MÁS  •  PROMOCIONES ESPECIALES'}
                      </div>
                    </div>
                  </a>
                )
              )
            : (
              <div className="marquee" style={{
                background: 'var(--color-black-block)',
                color: 'var(--color-cta-text)',
                fontFamily: 'var(--font-display)',
                fontSize: '0.875rem',
                padding: '0.5rem 0',
                overflow: 'hidden',
                whiteSpace: 'nowrap'
              }}>
                <div className="marquee-content" style={{
                  display: 'inline-block',
                  animation: 'scroll-left 25s linear infinite',
                  paddingLeft: '100%'
                }}>
                  {heroConfig?.marquee_texto || '★ OFERTAS EXCLUSIVAS  •  DESCUENTOS LIMITADOS  •  AHORRA MÁS  •  PROMOCIONES ESPECIALES  •  OFERTAS EXCLUSIVAS  •  DESCUENTOS LIMITADOS  •  AHORRA MÁS  •  PROMOCIONES ESPECIALES'}
                </div>
              </div>
            )
          }
        </section>

        <div className="container" style={{ maxWidth: 'var(--container-max-width)', margin: '0 auto', padding: '0 2rem' }}>
          {/* Descuentos Section */}
          <section id="descuentos_main" role="region" aria-label="Descuentos Vigentes">
            <div style={{ marginBottom: '2.5rem', marginTop: '1.5rem' }}>
              <h2 style={{
                position: 'absolute',
                width: '1px',
                height: '1px',
                padding: 0,
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0, 0, 0, 0)',
                whiteSpace: 'nowrap',
                border: 0
              }}>Descuentos Vigentes</h2>
            </div>

            {activeDescuentos.length === 0 ? (
              <div style={{
                background: 'var(--color-accent-gray)',
                padding: '3rem 2rem',
                borderRadius: 'var(--radius-md)',
                textAlign: 'center',
                marginBottom: '3rem'
              }}>
                <p style={{ 
                  color: 'var(--color-text-muted)',
                  fontFamily: 'var(--font-ui)',
                  fontSize: 'var(--font-size-body)'
                }}>No hay descuentos vigentes en este momento.</p>
              </div>
            ) : (
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(3, 1fr)', 
                gap: '1rem',
                marginBottom: '3rem'
              }}>
                {activeDescuentos.map((d) => (
                  <Link 
                    key={d.id} 
                    to={`/descuentos/${d.id}`} 
                    style={{
                      textDecoration: 'none',
                      background: 'white',
                      borderRadius: 'var(--radius-lg)',
                      overflow: 'hidden',
                      border: '1px solid var(--color-stroke)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                      cursor: 'pointer',
                      display: 'block'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)'
                      e.currentTarget.style.boxShadow = 'var(--shadow-card)'
                      e.currentTarget.style.outline = '1px solid var(--brand-green-200)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)'
                      e.currentTarget.style.boxShadow = 'none'
                      e.currentTarget.style.outline = 'none'
                    }}
                    onTouchStart={(e) => {
                      e.currentTarget.style.transform = 'scale(0.98)'
                      e.currentTarget.style.boxShadow = '0 0 0 3px var(--brand-green-200)'
                      e.currentTarget.style.outline = '1px solid var(--brand-green-200)'
                    }}
                    onTouchEnd={(e) => {
                      setTimeout(() => {
                        e.currentTarget.style.transform = 'translateY(0)'
                        e.currentTarget.style.boxShadow = 'none'
                        e.currentTarget.style.outline = 'none'
                      }, 150)
                    }}
                  >
                    {d.imagen_url && (
                      <img 
                        src={d.imagen_url} 
                        alt={d.imagen_alt || d.titulo} 
                        style={{ 
                          width: '100%', 
                          height: '200px', 
                          objectFit: 'cover' 
                        }} 
                      />
                    )}
                    <div style={{ padding: '1rem' }}>
                      <h3 style={{
                        fontFamily: 'var(--font-ui)',
                        fontSize: 'var(--font-size-h3)',
                        fontWeight: 'var(--font-weight-bold)',
                        color: 'var(--color-text-primary)',
                        margin: '0 0 0.5rem 0'
                      }}>{d.titulo}</h3>
                      <p style={{
                        fontSize: 'var(--font-size-small)',
                        color: 'var(--color-text-muted)',
                        margin: 0
                      }}>
                        Vigencia: {d.fecha_inicio} {d.fecha_fin ? `— ${d.fecha_fin}` : ''}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </section>
        </div>
      </main>

      <style>{`
        @media (min-width: 600px) and (max-width: 1023px) {
          .container {
            padding: 0 1.5rem !important;
          }
          .container > section > div:last-child {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }

        @media (max-width: 599px) {
          .container {
            padding: 0 1rem !important;
            padding-top: 0rem !important;
          }
          .container > section > div:last-child {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </>
  )
}
